import { Box, Typography } from "@mui/material";

import SouthIcon from "@mui/icons-material/South";

import "./LiveCoupon.css";

interface propsType {
  hidden_menu: boolean;
  openCpnList: Function;
}

export default function LiveCoupon({ hidden_menu, openCpnList }: propsType) {
  const openCouponList = () => {
    openCpnList();
  };

  return (
    <Box
      className="live-coupon-img-root"
      sx={
        hidden_menu ? { display: "none" } : { display: "flex", zIndex: "1000" }
      }
    >
      <Box className="live-coupon-img-container" onClick={openCouponList} />
      {/* <Typography>쿠폰받기</Typography>
        <SouthIcon sx={{ height: "1.2rem" }}/> */}
      {/* <Box className="live-coupon-price">
          <Typography className={"10" === "10" ? "live-coupon-txt-num" : "live-coupon-txt-rate"}>
            {cUtils.numericComma(coupons[0].cpnAplyVal)}
            1,000원
            {coupons[0].cpnAplyMethCd === "10" ? "원" : "%"}
          </Typography>
        </Box> */}
    </Box>
  );
}
